import type { FaireProductEntity } from "../../entity_types/product";

export const p_hkghte4qrs: FaireProductEntity = {
  token: "p_hkghte4qrs",
  type: "product",
  name: "Crushed It Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/dcab94df562a78711348f3e55ccfd4db23dfe4e45e59cdc17cd0fed4be13f4cb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/abf8613be149c5203887c5b5a09a04bc35fda9f65b2c911424379f2f21f8d216.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:18.925Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
